<template>
    <div>A/B</div>
</template>

<script>
    export default {
        name: 'AB',
    };
</script>

<style scoped>

</style>